import { createContext, useState } from "react";

const factorFilterContext = createContext({
    filterDate: { value: [], isActive: 0 },
    filterBread: { value: [], isActive: 0 },
    setFilterDate: () => { },
    setFilterBread: () => { },
});

export function FactorFilterProvider(props) {
    const [filterDate, setFilterDate] = useState({ value: [new Date()], isActive: 0 });
    const [filterBread, setFilterBread] = useState({
        value: [],
        isActive: 0,
    });

    const context = {
        filterDate,
        setFilterDate,
        filterBread,
        setFilterBread,
    };

    return (
        <factorFilterContext.Provider value={context}>
            {props.children}
        </factorFilterContext.Provider>
    );
}

export default factorFilterContext;
